import baseService from '../../utils/axios';
import { IntegrationConfig } from '../../interfaces/integrations';

export async function getGorgiasConfig(): Promise<IntegrationConfig | null> {
  const response = await baseService.get<{ config: IntegrationConfig }>('/integrations/get_service_config', {
    params: { service_name: 'gorgias' },
    // An account without a saved subdomain has no service configuration yet.
    validateStatus: (status) => status === 200 || status === 404
  });
  return response.status === 404 ? null : response.data.config;
}

export async function saveGorgiasSubdomain(subdomain: string): Promise<string> {
  const response = await baseService.put<{ subdomain: string }>('/gorgias/subdomain', { subdomain });
  return response.data.subdomain;
}

export async function getGorgiasAuthUrl(): Promise<string> {
  const response = await baseService.get<{ url: string }>('/service_oauth/auth_url/gorgias');
  if (!response.data.url) {
    throw new Error('Failed to get the Gorgias authorization URL. Please try again.');
  }
  return response.data.url;
}

export async function completeGorgiasOAuth(urlParams: Record<string, string>): Promise<void> {
  await baseService.post('/service_oauth/callback/gorgias', { url_params: urlParams });
}

export async function removeGorgiasAuth(): Promise<void> {
  await baseService.post('/gorgias/remove_auth');
}

export function getGorgiasErrorMessage(error: unknown, fallback: string): string {
  // The shared Axios interceptor rejects with the response body directly.
  if (error && typeof error === 'object') {
    const details = error as { detail?: unknown; error?: unknown; message?: unknown };
    for (const message of [details.detail, details.error, details.message]) {
      if (typeof message === 'string' && message.trim()) {
        return message;
      }
    }
  }
  return typeof error === 'string' && error.trim() ? error : fallback;
}
